import { Expose } from "class-transformer";

type CreditTrustError = 'NOT_FOUND';
export class CreditTrustDTO {

  public scale: number = 0;
  public zone: number = 0;
  public cluster: number = 0;
  public homogeneity: number = 0;
  public balance: number = 0;
  public weather: number = 0;
  
  @Expose({ name: "track_record" })
  public trackRecord: number = 0;

  @Expose({ name: "general_score" })
  public generalScore: number = 0;

  public status!: string;

  public error?: CreditTrustError;

  get generalScoreTo100() {

    const base = (this.scale > 0 ? 100: 0) +
      (this.zone > 0 ? 100: 0) +
      (this.cluster > 0 ? 100: 0) +
      (this.homogeneity > 0 ? 100: 0) +
      (this.balance > 0 ? 100: 0) +
      (this.weather > 0 ? 100: 0) +
      (this.trackRecord > 0 ? 100: 0);
    
    if (base === 0) return base;

    return Math.round(this.generalScore / base * 100)
  }

  public static generateEmptyWithError(error: CreditTrustError) {
    const o = new CreditTrustDTO();
    o.status = 'ERROR';
    o.error = error;
    return o;
  }

}
